// Generated from products/analytics/integrations/chatPublicBrowser.ts; run analytics generate:site-runtime.
import {
  chatAnalyticsOptedOut,
  createChatPublicAnalytics,
  type ChatPublicSurface,
} from "./chatPublic.gen";

/** One installation per document; callers own route subscriptions and HMR cleanup. */
export function installChatPublicBrowser(surface: ChatPublicSurface, configs: unknown) {
  let publicEntry = true;
  const analytics = createChatPublicAnalytics({
    surface,
    configs,
    location: () => window.location,
    optedOut: () =>
      !publicEntry ||
      chatAnalyticsOptedOut(navigator, (window as Window & { doNotTrack?: string }).doNotTrack),
  });
  const update = () => analytics.update();
  const route = (event: Event) => {
    publicEntry = event instanceof CustomEvent && event.detail === true;
    update();
  };
  const click = (event: MouseEvent) => {
    try {
      if (event.defaultPrevented || !(event.target instanceof Element)) return;
      const anchor = event.target.closest("a");
      const href = anchor?.getAttribute("href");
      // Read only the fixed target. Never read text, labels, input values or arbitrary URL fields.
      if (
        [
          "/chat",
          "/chat/",
          `${window.location.origin}/chat`,
          `${window.location.origin}/chat/`,
        ].includes(href ?? "")
      )
        analytics.openChat();
    } catch {
      /* Navigation continues. */
    }
  };
  window.addEventListener("popstate", update);
  window.addEventListener("hashchange", update);
  window.addEventListener("chat:public-entry", route);
  if (surface === "landing") document.addEventListener("click", click);
  update();
  return {
    update,
    close() {
      window.removeEventListener("popstate", update);
      window.removeEventListener("hashchange", update);
      window.removeEventListener("chat:public-entry", route);
      if (surface === "landing") document.removeEventListener("click", click);
      analytics.close();
    },
  };
}
